export enum ConsensusHistoryLogAction {
  LOCK = 'LOCK',
  UNLOCK = 'UNLOCK',
  /**
   * use CREATE when it's a direct user input value - not a calculated one
   */
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  /**
   * use RECONCILED when it's a reconciled value
   */
  RECONCILED = 'RECONCILED',
  /**
   * use CYCLE_CARRIED when the value was carried over from a previous cycle
   * (written by the carry-forward job, never by a user request)
   */
  CYCLE_CARRIED = 'CYCLE_CARRIED',
  /**
   * use RESET when a user resets a cell back to the current forecast value
   * (PM-4317). Value-bearing: the log carries the forecast value the cell
   * returned to. On a parent reset the cascade writes RESET rows to the
   * affected leaves too, so they resolve back to Forecast-inherited.
   */
  RESET = 'RESET',
}
